import { useDispatch, useSelector } from 'react-redux';
import {
  selectExportProgress,
  selectShowProgressBar,
  setRunningInBackground,
  setShowExportProgressBar,
} from '../../../store/slices/export-ppt.slice';
import { ExportProgressBar } from './ExportProgressBar';

export function PowerpointExportProgressBar() {
  const value = useSelector(selectExportProgress);
  const show = useSelector(selectShowProgressBar);
  const dispatch = useDispatch();

  const minimizeExportProgressBar = () => {
    dispatch(setShowExportProgressBar(false));
    dispatch(setRunningInBackground(true));
  };

  return (
    <ExportProgressBar
      value={value}
      show={show}
      title="Hang tight, your PowerPoint’s on its way!"
      subtitle="It will auto-download & be saved to My Files."
      onClose={minimizeExportProgressBar}
    />
  );
}
